import {useRoute} from "vue-router";

export default defineNuxtPlugin(() => {
    const homeDesignsDiv = document.querySelector('.home-designs');

    if (!import.meta.client || !homeDesignsDiv) {
        return;
    }

    const route = useRoute();

    const houseDesignLinks = document.querySelectorAll('.house-design-link');
    const blockWidthInput = document.querySelector('#filter-block-width');
    const houseSizeInput = document.querySelector('#filter-house-size');
    const storeysInput = document.querySelector('#filter-storeys');
    const bathInput = document.querySelector('#filter-bath');
    const carInput = document.querySelector('#filter-car');
    const bedInput = document.querySelector('#filter-bed');



    const filterHouses = () => {
        const filterBlock = parseFloat(blockWidthInput.value);
        const filterSize = parseFloat(houseSizeInput.value);
        const filterStorey = storeysInput.value.toString();
        const filterBath = bathInput.value.toString();
        const filterCar = carInput.value.toString();
        const filterBed = bedInput.value.toString();

        document.querySelectorAll('.house-item').forEach(item => {
            const sizes = JSON.parse(item.dataset.sizes);
            const blocks = JSON.parse(item.dataset.blocks);
            const carSpaces = JSON.parse(item.dataset.carSpaces);
            const bedrooms = JSON.parse(item.dataset.bedrooms);
            const storeys = JSON.parse(item.dataset.storeys);
            const bathrooms = JSON.parse(item.dataset.bathrooms);

            if ((blocks.filter(v => parseFloat(v) <= filterBlock).length > 0)
                && (sizes.filter(v => parseFloat(v) <= filterSize).length > 0)
                && (filterCar === "-" || carSpaces.includes(filterCar))
                && (filterBed === "-" || bedrooms.includes(filterBed))
                && (filterBath === "-" || bathrooms.includes(filterBath))
                && (filterStorey === "-" || storeys.includes(filterStorey))
            ) {
                item.classList.remove("d-none");
            } else if (!item.classList.contains("d-none")) {
                item.classList.add("d-none");
            }
        });

        const houseItems = document.querySelectorAll('.house-item:not(.d-none)');

        if (houseItems.length == 0) {
            document.querySelector('#our-homes-no-results').classList.remove('d-none');
        } else {
            document.querySelector('#our-homes-no-results').classList.add('d-none');
        }

    };

    const updateInputRange = (e) => document
        .getElementById(e.target.dataset.target)
        .innerText = e.target.value;

    const resetAllFilters = () => {
        // Get initial max values from data attributes
        const houseItems = document.querySelectorAll('.house-item');
        let allBlocks = [];
        let allSizes = [];

        houseItems.forEach(item => {
            allBlocks = allBlocks.concat(JSON.parse(item.dataset.blocks));
            allSizes = allSizes.concat(JSON.parse(item.dataset.sizes));
        });

        const maxBlocks = Math.max(...allBlocks.map(v => parseFloat(v)));
        const maxSize = Math.max(...allSizes.map(v => parseFloat(v)));

        // Reset range inputs
        blockWidthInput.value = Math.ceil(maxBlocks);
        houseSizeInput.value = Math.ceil(maxSize);

        // Reset select inputs
        bedInput.value = '-';
        bathInput.value = '-';
        carInput.value = '-';
        storeysInput.value = '-';

        // Update range display values
        document.getElementById('block-input-range-value').innerText = Math.ceil(maxBlocks);
        document.getElementById('size-input-range-value').innerText = Math.ceil(maxSize);

        // Show all house items
        document.querySelectorAll('.house-item').forEach(item => {
            item.classList.remove('d-none');
        });

        // Hide no results message
        const noResultsElement = document.querySelector('#our-homes-no-results');
        if (noResultsElement) {
            noResultsElement.classList.add('d-none');
        }

    };

    blockWidthInput.addEventListener('input', updateInputRange);
    houseSizeInput.addEventListener('input', updateInputRange);
    blockWidthInput.addEventListener('change', filterHouses);
    houseSizeInput.addEventListener('change', filterHouses);
    storeysInput.addEventListener('change', filterHouses);
    bathInput.addEventListener('change', filterHouses);
    carInput.addEventListener('change', filterHouses);
    bedInput.addEventListener('change', filterHouses);


    // Add event listener for reset button
    const resetButton = document.querySelector('#reset-filters-btn');
    if (resetButton) {
        resetButton.addEventListener('click', resetAllFilters);
    }


    if (route.query.hasOwnProperty('width')) {
        blockWidthInput.value = parseInt(route.query.width);
        filterHouses();
    }
});
